import { RequiredQueryKeyFilter, createDefaultQueryKeysGenerator } from 'core/query/constants';

interface GrafanaQueryDetailKeyFilter extends RequiredQueryKeyFilter {
  dashboardUid: string;
  panelId?: number;
  variables?: Record<string, string | number>;
  width?: number;
  height?: number;
  from?: string;
  to?: string;
}

type GrafanaQueryListKeyFilter = RequiredQueryKeyFilter;

export const grafanaQueryKeys = createDefaultQueryKeysGenerator<
  GrafanaQueryListKeyFilter,
  GrafanaQueryDetailKeyFilter
>({
  keyDataType: 'grafana',
});
